<template>
    <DxDataGrid :data-source="dsTipuriConcedii" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Type">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="350" :height="410" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid :col-count="1">
                <DxItem data-field="Name"/>
                <DxItem data-field="NrZile" editor-type="dxNumberBox"/>
                <DxItem data-field="Order" editor-type="dxNumberBox"/>
                <DxItem data-field="Suspended" editor-type="dxCheckBox" :css-class="'checkbox-center'" :editor-options="{ elementAttr: { style: 'display:flex; justify-content:center; margin-right:110px;' } }"/>
            </DxFormGrid>
        </DxEditing>
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Tip Concediu
            </div>
        </template>

        <DxColumn data-field="Type" caption="Tip"/>
        <DxColumn data-field="Name" caption="Nume"/>
        <DxColumn data-field="Suspended" caption="Suspendat?"/>
        <DxColumn data-field="NrZile" caption="Numar Zile"/>
        <DxColumn data-field="Order" caption="Comanda"/>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="350" height="350">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Tip Concediu
            </div>
        </template>
        <DxForm :col-count="2" :data-dource="newConcediu">
            <DxSimpleItem data-field="Tip" :is-required="true">
                <template #default>
                    <DxTextArea :value="newConcediu.Type" @value-changed="onTypeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newConcediu.Name" @value-changed="onNameValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Numar Zile">
                <template #default>
                    <DxNumberBox :value="newConcediu.NrZile" :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" @value-changed="onNrZileValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Numar Zile">
                <template #default>
                    <DxNumberBox :value="newConcediu.Order" :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" @value-changed="onOrderValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Suspendat?" :is-required="true" :col-span="2">
                <template #default>
                    <div style="display: flex; justify-content: center;">
                        <DxCheckBox :value="newConcediu.Suspended" @value-changed="onSuspendedValueChanged"/>
                    </div>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
    import {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxPopup,
        DxItem,
        DxItem as DxFormItem,
        DxForm as DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxSearchPanel,
    } from 'devextreme-vue/data-grid';
    import DxDateBox from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import AppSetting from '@/settings/appSettings';
    import { defineComponent, ref } from 'vue';
    import DataSource from 'devextreme/data/data_source';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxForm, DxSimpleItem } from "devextreme-vue/form"
    import DxPopupAdd from 'devextreme-vue/popup'
    import { DxToolbarItem } from 'devextreme-vue/popup';
    import { DxNumberBox } from "devextreme-vue/number-box";
    import PER_VacationTypes from '@/services/PER/PER_VacationTypes';

    export default defineComponent({
        components: {
            DxColumn,
            DxDataGrid,
            DxFilterRow,
            DxLoadPanel,
            DxPaging,
            DxSelection,
            DxSorting,
            DxStateStoring,
            DxToolbar,
            DxEditing,
            DxValidationRule,
            DxRequiredRule,
            DxItem,
            DxButton,
            DxSearchPanel,
            DxForm,
            DxPopupAdd,
            DxSimpleItem,
            DxTextArea,
            DxCheckBox,
            DxToolbarItem,
            DxPopup,
            DxFormGrid,
            DxFormItem,
            DxDateBox,
            DxNumberBox
        },
        data() {
            return {
                dsTipuriConcedii: {} as DataSource,
                dataGridRef: ref<DxDataGrid | null>(null),
                deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
                addPopupVisible: false,
                newConcediu: {
                    Type: '',
                    Name: '',
                    Suspended: null,
                    NrZile: null,
                    Order: null,
                },
                addButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveAdd()
                    }
                },
                saveButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveEdit()
                    }
                },
                closeButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onCloseAdd()
                    }
                },
                dangerButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.closeEditPopup()
                    }
                },
            }
        },
        mounted() {
            this.dsTipuriConcedii = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `PER_VacationTypes`,
                    key: 'Type',
                    keyType: 'String',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            })
            this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
            this.setDeleteConfirmationMessage()
        },
        methods: {
            setDeleteConfirmationMessage() {
                const dataGrid = this.$refs.dataGridRef?.instance;
                dataGrid.option('editing', {
                    allowUpdating: true,
                    allowDeleting: true,
                    mode: 'popup',
                    texts: {
                        confirmDeleteMessage: this.deleteConfirmationMessage,
                        confirmDeleteTitle: "Confirmare Ștergere",
                    }
                });
            },
            onRefreshClick() {
                const gridInstance = this.dataGridRef?.instance;
                if (gridInstance) {
                    gridInstance.refresh();
                    notify("Datele au fost actualizate cu succes!", "success", 3000);
                }
            },
            onAddClick() {
                this.addPopupVisible = true
            },
            onCloseAdd() {
                this.addPopupVisible = false
                this.newConcediu.Type = ''
                this.newConcediu.Name = ''
                this.newConcediu.Suspended = null
                this.newConcediu.NrZile = null
                this.newConcediu.Order = null
            },
            closeEditPopup() {
                this.dataGridRef?.instance?.cancelEditData();
            },
            async onSaveEdit() {
                const gridInstance = this.dataGridRef?.instance;
                if (!gridInstance) {
                    notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                    return; 
                }
                try {
                    gridInstance.saveEditData()
                    notify('Datele au fost salvate cu succes!', 'success', 2000);
                } catch (error: any) {
                    console.error("Eroare la salvarea editării:", error);
                }
            },
            onSaveAdd() {
                if (!this.newConcediu.Type || this.newConcediu.Type.trim() === "") {
                    notify("Vă rog să completați câmpul obligatoriu 'Tip'!", "error", 3000)
                    return
                }

                if (!this.newConcediu.Name || this.newConcediu.Name.trim() === "") {
                    notify("Vă rog să completați câmpul obligatoriu 'Nume'!", "error", 3000)
                    return
                }

                if (this.newConcediu.Suspended === null) {
                    notify("Vă rog să completați câmpul obligatoriu 'Suspendat?'!", "error", 3000)
                    return
                }

                PER_VacationTypes.save(this.newConcediu).then((concediu) => {
                    this.addPopupVisible = false
                    notify('Datele au fost salvate cu succes!', 'success', 2000)
                    this.newConcediu = {
                        Type: '',
                        Name: '',
                        Suspended: null,
                        NrZile: null,
                        Order: null
                    }
                    this.onRefreshClick()
                }).catch((error) => {
                    console.error(error)
                    notify("Datele exista deja!", 'error', 3000)
                })
            },
            onTypeValueChanged(e: any) {
                this.newConcediu.Type = e.value
            },
            onNameValueChanged(e: any) {
                this.newConcediu.Name = e.value
            },
            onSuspendedValueChanged(e: any) {
                this.newConcediu.Suspended = e.value
            },
            onNrZileValueChanged(e: any) {
                this.newConcediu.NrZile = e.value
            },
            onOrderValueChanged(e: any) {
                this.newConcediu.Order = e.value
            }
        }
    })
</script>